import api from './axios';

export const getContracts = async (params) => {
  const response = await api.get('/contracts', { params });
  return response.data;
};

export const getContract = async (id) => {
  const response = await api.get(`/contracts/${id}`);
  return response.data;
};

export const createContract = async (data) => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });
  const response = await api.post('/contracts', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updateContract = async (id, data) => {
  const response = await api.put(`/contracts/${id}`, data);
  return response.data;
};

export const uploadContractDocument = async (id, file) => {
  const formData = new FormData();
  formData.append('document', file);
  const response = await api.post(`/contracts/${id}/upload-document`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteContract = async (id) => {
  const response = await api.delete(`/contracts/${id}`);
  return response.data;
};

export const getExpiringSoon = async () => {
  const response = await api.get('/contracts/expiring/soon');
  return response.data;
};

export const getByStatus = async (status) => {
  const response = await api.get(`/contracts/status/${status}`);
  return response.data;
};

export const renewContract = async (id) => {
  const response = await api.post(`/contracts/${id}/renew`);
  return response.data;
};

export const terminateContract = async (id) => {
  const response = await api.post(`/contracts/${id}/terminate`);
  return response.data;
};
